<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-19 18:32:37
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-08-23 16:48:26
 * @FilePath: \onetab\src\views\share-page\index.vue
-->
<template>
  <div
    class="share-container"
    :style="{
      backgroundImage: `url(${
        settings.wallpaper || 'https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/default_bg.jpg'
      })`,
      transition: 'filter 0.5s ease, background-image 0.5s ease',
      backdropFilter: 'blur(0px)',
    }"
  >
    <div class="header">
      <div class="logo-cont" @click="handleHome">
        <div class="logo">
          <img
            :src="
              settings.theme !== 'light'
                ? require('../../assets/logo.png')
                : require('../../background/Logo.png')
            "
            alt=""
          />
        </div>
        <div class="name">MiTab</div>
      </div>
      <div class="install-cont">
        <div class="text" @click="handleInstall">安装插件</div>
        <div class="text" @click="handleLogin">登录 / 注册</div>
      </div>
    </div>

    <div class="share-marks">
      <SideBar :list="categories" @change-category="handleCategory" />
      <div class="content">
        <div
          :class="{ item: true, [`item-${item.type}`]: true }"
          v-for="item in booksMarks"
          :key="item.uuid"
          @click="handleMark(item)"
        >
          <img v-if="item.icon" :src="item.icon" class="icon" />
          <div v-else class="icon" :style="{ background: item.color }">
            {{ item.name }}
          </div>
          <div v-if="item.type === 3" class="desc">
            <div class="desc-name">{{ item.name }}</div>
            <div class="describe">{{ item.describe || item.name }}</div>
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
      <div class="share-btn" @click="handleSaveMark">保存书签</div>
    </div>
  </div>
  <ShareModal
    type="save"
    :visible="visible"
    @close="visible = false"
    :code="linkCode"
  />
  <SettingModal
    class="setting-modal"
    v-if="showSetting"
    @handleClose="showSetting = false"
    key="setting"
    :selected="settingSelected"
  />
  <LittleComponent
    v-if="showLittleComponent"
    @close="showLittleComponent = false"
    :detail="detail"
  />
</template>
<script setup>
import { ref, onMounted } from 'vue';
import SettingModal from '@/components/SettingModal.vue';
import { settings } from '@/store/settings';
import { user } from '@/store/user';
import SideBar from './components/SideBar.vue';
import { RaButton, RaMessage } from '@rafter/pc';
import { getShareDetail } from '@/api/baseApi';
import ShareModal from '@/components/ShareModal.vue';
import LittleComponent from '@/external-components/index.vue';
import { bookmarks } from '@/store/bookmarks';
import { plugins } from '@/store/plugins';
import { useRouter } from 'vue-router';
const showSetting = ref(false);
const showLittleComponent = ref(false);
const router = useRouter();
const settingSelected = ref({
  name: '通用',
  value: 'common',
});
const detail = ref({});
const booksMarks = ref([]);
const categories = ref([]);
const visible = ref(false);
const linkCode = ref('');
const handleCategory = (item) => {
  booksMarks.value = item.bookmarks;
};
const handleSaveMark = () => {
  if (!user.token) {
    settingSelected.value = { name: '登录', value: 'login' };
    return (showSetting.value = true);
  }
  visible.value = true;
};
onMounted(() => {
  const code = window.location.href.split('?code=')[1];
  if (code) {
    linkCode.value = code;
    getShareDetail(code).then((res) => {
      if (+res.data.code === 200) {
        categories.value = res.data.data.categories;
        booksMarks.value = res.data.data.categories[0].bookmarks;
      }
    });
  }
});
const handleMark = (item) => {
  if (item.type !== 3) {
    bookmarks.gotoMark(item);
  } else {
    const target = plugins.list.find((plu) => {
      return plu.url === item.url;
    });
    if (target && target.authority > 1 && !user.token) {
      showSetting.value = true;
      return;
    }
    detail.value = item;
    showLittleComponent.value = true;
  }
};
const handleInstall = () => {
  window.open(
    'https://microsoftedge.microsoft.com/addons/detail/jgppdpcaejiofmhenoimdbnfdbajfiip'
  );
};
const handleHome = () => {
  router.push('/');
};
const handleLogin = () => {
  if (user.token) {
    settingSelected.value = { name: '账号', value: 'ucenter' };
  } else {
    settingSelected.value = { name: '登录', value: 'login' };
  }
  showSetting.value = true;
};
</script>
<style lang="scss" scoped>
.share-container {
  background: url(https://onetab-1309784708.cos.ap-shanghai.myqcloud.com/default_bg.jpg) center no-repeat;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  user-select: none;
  .header {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
    padding: 30px 30px;
    width: -webkit-fill-available;
    justify-content: space-between;
    .logo-cont {
      align-items: center;
      display: flex;
      gap: 12px;
      cursor: pointer;
      .logo {
        display: flex;
        width: 22px;
        height: 22px;
        padding: 5px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 7px;
        @include background('logo-background-color');
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        @include font_color('base-bg-color-09');
        font-family: 'PingFang SC';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 155.556% */
        @include font_color('base-bg-color-09');
        font-family: 'PingFang SC';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 2px;
      }
    }
    .install-cont {
      display: flex;
      align-items: center;
      gap: 40px;
      .text {
        @include font_color('base-bg-color-09');
        /* One/Side Icon */
        text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.16);
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 157.143% */
        cursor: pointer;
      }
    }
  }

  .share-marks {
    width: 75%;
    height: 75%;
    position: relative;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    &::before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(102, 102, 102, 0.6);
      background-blend-mode: overlay;
      backdrop-filter: blur(60px);
      border-radius: 32px;
    }
    .content {
      height: 69%;
      width: 72.1%;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: grid;
      gap: 64px;
      grid-template-columns: repeat(auto-fill, 72px);
      grid-template-rows: repeat(auto-fill, 72px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }

      /* 隐藏滚动条轨道 */
      &::-webkit-scrollbar-track {
        display: none;
      }

      /* 隐藏滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        display: none;
      }
      // .item-3 {
      //   grid-column: span 1; /* 占用1列 */
      //   grid-row: span 1; /* 占用1行 */
      // }
      // .item-2 {
      //   grid-column: span 2; /* 占用1列 */
      //   grid-row: span 1; /* 占用1行 */
      // }
      // .item-1 {
      //   grid-column: span 2; /* 占用1列 */
      //   grid-row: span 2; /* 占用1行 */
      // }
      // .item-0 {
      //   grid-column: span 4; /* 占用1列 */
      //   grid-row: span 2; /* 占用1行 */
      // }
      .item {
        position: relative;
        cursor: pointer;
        .icon {
          width: 100%;
          height: 100%;
          border-radius: 20px;
          align-items: center;
          display: flex;
          justify-content: center;
          @include font_color('base-bg-color-09');
          font-size: 24px;
          font-weight: 600;
          overflow: hidden;
          box-sizing: border-box;
        }
        .name {
          position: absolute;
          max-width: 100%;
          transform: translateX(-50%);
          left: 50%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.16);
          font-family: 'PingFang SC';
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 153.846% */
          letter-spacing: 0.4px;
          color: var(--white-90, rgba(255, 255, 255, 0.9));
          bottom: -24px;
        }
      }
      .item-1 {
        grid-column: span 1;
        grid-row: span 1;
      }
      .item-3 {
        grid-column: span 2;
        grid-row: span 1;
        display: flex;
        background: white;
        gap: 6px;
        border-radius: 20px;
        align-items: center;
        padding: 8px;
        .icon {
          border-radius: 50%;
          width: 40px;
          height: 40px;
          align-items: center;
        }
        .desc {
          .desc-name {
            font-size: 14px;
            font-weight: 600;
          }
          .describe {
            font-size: 12px;
            color: #777;
          }
        }
      }
    }
    .share-btn {
      position: absolute;
      right: 32px;
      top: 32px;
      display: flex;
      padding: 8px 12px;
      align-items: center;
      border-radius: 6px;
      background: var(--background-default, rgba(250, 250, 250, 0.9));
      background-blend-mode: luminosity;
      backdrop-filter: blur(40px);
      color: var(--One-Selected, #007aff);
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      cursor: pointer;
    }
  }
}
</style>
